export default __webpack_public_path__ + "static/media/dubai-internet-city.be067f06.png";